import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'WORDS_UPDATE',
    smsDelete : 'WORDS_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        location: [],
        locationLoading: false,
        locationError: false,

        words: [],
        submitSuccess: false,
        wordsLoading: false,
        wordsError: false,

        submission_list: [],

        submission_details: null,
        submissionLoading: false,
        submissionError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_LOCATION(state, results) {
            state.location = results;
        },

        LOCATION_LOADING (state, loading) {
            state.locationLoading = loading;
        },

        LOCATION_ERROR (state, hasError) {
            state.locationError = hasError;
        },

        SET_WORDS(state, results) {
            state.words = results;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        WORDS_LOADING (state, loading) {
            state.wordsLoading = loading;
        },

        WORDS_ERROR (state, hasError) {
            state.wordsError = hasError;
        },

        SET_STUDENT_SUBMISSIONS(state, results) {
            state.submission_list = results;
        },

        SET_SUBMISSION_DETAILS(state, results) {
            state.submission_details = results;
        },

        SUBMISSION_LOADING (state, loading) {
            state.submissionLoading = loading;
        },

        SUBMISSION_ERROR (state, hasError) {
            state.submissionError = hasError;
        }
    },

    actions: {
        async fetchLocation ({ commit }) {
            commit('LOCATION_LOADING', true);
            commit('LOCATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.location_list, config);
                let response = result.data
                commit('SET_LOCATION', response);
                return result
            } catch(error) {
                commit('LOCATION_ERROR', true);
            } finally {
                commit('LOCATION_LOADING', false);
            }
        },

        // Words
        async addWords ({commit, dispatch}, payload) {
            commit('WORDS_LOADING', true);
            commit('WORDS_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_experience, payload.item, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchWords')
                return response

            } catch (e) {
                commit('WORDS_ERROR', true);
            } finally {
                commit('WORDS_LOADING', false);
            }
        },

        async fetchWords ({ commit }) {
            commit('WORDS_LOADING', true);
            commit('WORDS_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.experience_list, config);
                let response = result.data.data
                commit('SET_WORDS', response);
                return result
            } catch(error) {
                commit('WORDS_ERROR', true);
            } finally {
                commit('WORDS_LOADING', false);
            }
        },

        async updateWords ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_experience + payload.id, payload.item, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchWords')
                return response

            } catch (e) {
                commit('WORDS_ERROR', true);
            } finally {
                commit('WORDS_LOADING', false);
            }
        },

        async deleteWords({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_experience + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchWords')
            return response
        },

        // Student Submissions
        async fetchStudentSubmissions ({ commit }) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.form_submission_list, config);
                let response = result.data.data
                commit('SET_STUDENT_SUBMISSIONS', response);
                return result
            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async fetchSubmissionDetails ({ commit }, payload) {
            commit('SUBMISSION_LOADING', true);
            commit('SUBMISSION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.form_submission_details + payload, config);
                let response = result.data.data
                commit('SET_SUBMISSION_DETAILS', response);
                return result
            } catch(error) {
                commit('SUBMISSION_ERROR', true);
            } finally {
                commit('SUBMISSION_LOADING', false);
            }
        },

        async deleteSubmission({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_submission + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchStudentSubmissions')
            return response
        }
    },

    getters: {}
}
